import Immutable from 'immutable';
import { createReducer } from 'redux-immutablejs';
import * as emailSignUpActions from 'actions/email-sign-up';
import * as oAuthSignInActions from 'actions/oauth-sign-in';
import * as serverActions from 'actions/server';
import * as signOutActions from 'actions/sign-out';
import * as uiActions from 'actions/ui';

const initialState = Immutable.fromJS({
  emailSignInSuccessModalVisible:          false,
  emailSignInErrorModalVisible:            false,
  oAuthSignInSuccessModalVisible:          false,
  oAuthSignInErrorModalVisible:            false,
  oAuthSignInLoadingProvider:              null,
  signOutSuccessModalVisible:              false,
  signOutErrorModalVisible:                false,
  emailSignUpSuccessModalVisible:          false,
  emailSignUpAddress:                      null,
  firstTimeLoginSuccessModalVisible:       false,
  firstTimeLoginErrorModalVisible:         false,
  requestPasswordResetSuccessModalVisible: false,
  requestPasswordResetErrorModalVisible:   false,
  requestPasswordResetSuccessMessage:      null,
  updatePasswordSuccessModalVisible:       false,
  updatePasswordErrorModalVisible:         false,
  destroyAccountSuccessModalVisible:       false,
  destroyAccountErrorModalVisible:         false,
  destroyAccountMessage:                   null,
  passwordResetSuccessModalVisible:        false,
  passwordResetErrorModalVisible:          false
});

export default createReducer(initialState, {
  [oAuthSignInActions.OAUTH_SIGN_IN_COMPLETE]: state => state.merge({
    oAuthSignInSuccessModalVisible: true,
    oAuthSignInLoadingProvider: null
  }),

  [oAuthSignInActions.OAUTH_SIGN_IN_ERROR]: state => state.merge({
    oAuthSignInErrorModalVisible: true,
    oAuthSignInLoadingProvider: null
  }),

  [oAuthSignInActions.OAUTH_SIGN_IN_START]: (state, { provider }) => state.merge({
    oAuthSignInLoadingProvider: provider
  }),

  [uiActions.HIDE_EMAIL_SIGN_IN_SUCCESS_MODAL]: state => state.set(
    'emailSignInSuccessModalVisible', false
  ),

  [uiActions.HIDE_EMAIL_SIGN_IN_ERROR_MODAL]: state => state.set(
    'emailSignInErrorModalVisible', false
  ),

  [signOutActions.SIGN_OUT_COMPLETE]: state => state.set(
    'signOutSuccessModalVisible', true
  ),

  [signOutActions.SIGN_OUT_ERROR]: state => state.set(
    'signOutErrorModalVisible', true
  ),

  [uiActions.HIDE_SIGN_OUT_SUCCESS_MODAL]: state => state.set(
    'signOutSuccessModalVisible', false
  ),

  [uiActions.HIDE_SIGN_OUT_ERROR_MODAL]: state => state.set(
    'signOutErrorModalVisible', false
  ),

  [emailSignUpActions.EMAIL_SIGN_UP_COMPLETE]: (state, {user}) => state.merge({
    emailSignUpSuccessModalVisible: true,
    emailSignUpAddress: user.email
  }),

  [emailSignUpActions.EMAIL_SIGN_UP_ERROR]: state => state.set(
    'emailSignUpErrorModalVisible', true
  ),

  [uiActions.HIDE_EMAIL_SIGN_UP_SUCCESS_MODAL]: state => state.merge({
    emailSignUpSuccessModalVisible: false,
    emailSignUpAddress: null
  }),

  [uiActions.HIDE_EMAIL_SIGN_UP_ERROR_MODAL]: state => state.set(
    'emailSignUpErrorModalVisible', false
  ),

  [uiActions.SHOW_FIRST_TIME_LOGIN_SUCCESS_MODAL]: state => state.set(
    'firstTimeLoginSuccessModalVisible', true
  ),

  [uiActions.HIDE_FIRST_TIME_LOGIN_SUCCESS_MODAL]: state => state.set(
    'firstTimeLoginSuccessModalVisible', false
  ),

  [uiActions.HIDE_PASSWORD_RESET_SUCCESS_MODAL]: state => state.set(
    'passwordResetSuccessModalVisible', false
  ),

  [uiActions.SHOW_PASSWORD_RESET_SUCCESS_MODAL]: state => state.set(
    'passwordResetSuccessModalVisible', true
  ),

  [uiActions.SHOW_FIRST_TIME_LOGIN_ERROR_MODAL]: state => state.set(
    'firstTimeLoginErrorModalVisible', true
  ),

  [uiActions.HIDE_FIRST_TIME_LOGIN_ERROR_MODAL]: state => state.set(
    'firstTimeLoginErrorModalVisible', false
  ),

  [uiActions.HIDE_PASSWORD_RESET_ERROR_MODAL]: state => state.set(
    'passwordResetErrorModalVisible', false
  ),

  [uiActions.SHOW_PASSWORD_RESET_ERROR_MODAL]: state => state.set(
    'passwordResetErrorModalVisible', true
  ),

  [uiActions.HIDE_REQUEST_PASSWORD_RESET_SUCCESS_MODAL]: state => state.merge({
    requestPasswordResetSuccessModalVisible: false,
    requestPasswordResetSuccessMessage: null
  }),

  [uiActions.HIDE_REQUEST_PASSWORD_RESET_ERROR_MODAL]: state => state.set(
    'requestPasswordResetErrorModalVisible', false
  ),

  [uiActions.HIDE_OAUTH_SIGN_IN_SUCCESS_MODAL]: state => state.set(
    'oAuthSignInSuccessModalVisible', false
  ),

  [uiActions.HIDE_OAUTH_SIGN_IN_ERROR_MODAL]: state => state.set(
    'oAuthSignInErrorModalVisible', false
  ),

  [uiActions.HIDE_UPDATE_PASSWORD_SUCCESS_MODAL]: state => state.set(
    'updatePasswordSuccessModalVisible', false
  ),

  [uiActions.HIDE_UPDATE_PASSWORD_ERROR_MODAL]: state => state.set(
    'updatePasswordErrorModalVisible', false
  ),

  [uiActions.HIDE_DESTROY_ACCOUNT_SUCCESS_MODAL]: state => state.merge({
    destroyAccountSuccessModalVisible: false,
    destroyAccountMessage: null
  }),

  [uiActions.HIDE_DESTROY_ACCOUNT_ERROR_MODAL]: state => state.set(
    'destroyAccountErrorModalVisible', false
  ),

  [serverActions.SS_AUTH_TOKEN_UPDATE]: (state, {mustResetPassword, firstTimeLogin}) => state.merge({
    passwordResetSuccessModalVisible: mustResetPassword,
    firstTimeLoginSuccessModalVisible: firstTimeLogin
  }),

  [uiActions.HIDE_PASSWORD_RESET_SUCCESS_MODAL]: state => state.set(
    'passwordResetSuccessModalVisible', false
  ),

  [uiActions.HIDE_PASSWORD_RESET_ERROR_MODAL]: state => state.set(
    'passwordResetSuccessModalVisible', false
  ),
});



// WEBPACK FOOTER //
// ./src/reducers/auth/ui.js